import { createClient } from '@supabase/supabase-js';

// ТИМЧАСОВО: прямі значення для тесту
const supabaseUrl = 'https://hqteibhbvlaapumqsdqc.supabase.co';
const supabaseAnonKey = 'sb_publishable_fmatD8B4hKb3HliC_qPvjw_qeUbp4WW';

console.log('Using direct Supabase configuration');

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase configuration is missing');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);